// extracted by css-extract-rspack-plugin
export default {"accordionRoot":"FCO0Y","accordionItem":"Ng1iD","accordionControl":"oQwdI","accordionContent":"PHNdg","accordionChevron":"kFrub","accordionLabel":"FLFeH"};